import React, { useState, useEffect } from "react"

import { Row, Col, Input, Switch, Select, Space } from "antd"
import BulletPointTicket from "./components/BulletPointNew"
import person from "images/v2/person.png"
import mac from "images/landing-page/mac-image.png"
import Aos from "aos"
import "aos/dist/aos.css"
import { useMediaQuery } from "react-responsive"

const bulletPoints = [
  "Sistema veikia 24/7",
  "Visi užsakymai, sąskaitos ir siuntimų ataskaitos vienoje vietoje",
  "Išsamus siuntų sekimas",
  "Naudojimasis užsakymo valdymo sistema- nemokamas",
]

const ServiceSection = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })

  return (
    <>
      <Row
        style={{ 
          backgroundColor: "#F7F7F7",
          paddingBottom: "50px",
          paddingTop: "20px"
        }}
        gutter={{ lg: 16 }}
        className="front-page-section"
        align="middle"
      >
        

        <Col span={24} lg={{ span: 8, offset: 4 }}>
          <div
            style={{
              display: "flex",
              justifyContent: isMobileScreen ? "center" : "start",
            }}
          >
            <div data-aos={isMobileScreen ? "" : "fade-right"}>
              <img
                src={person}
                style={{
                  width: "100%",
                  maxWidth: "300px",
                  marginTop: isMobileScreen ? 30 : 50,
                  marginLeft: isMobileScreen && "-8%",
                }}
              />
            </div>
          </div>
        </Col>
        <Col span={24} lg={{ span: 12 }}>
          <div
            data-aos={isMobileScreen ? "" : "flip-left"}
            style={{
              display: "flex",
              justifyContent: isMobileScreen ? "center" : "start",
            }}
          >
            <div style={{ maxWidth: 600 }}>
              <div className="section-title" style={{ marginTop: "0px" }}>
                {"Patogi užsakymų valdymo sistema"}
              </div>

              <div
                className="section-sub-title"
                style={{ marginTop: "18px", marginBottom: "5px" }}
              >
                {"Lengvas užsakymų valdymas vos kelių mygtukų paspaudimu"}
              </div>

              {bulletPoints.map((point, index) => (
                <div className="section-bullet-point" key={index}>
                  <Space size="small" style={{ alignItems: "center" }}>
                    <BulletPointTicket />
                    <div>{point}</div>
                  </Space>
                </div>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default ServiceSection
